// extracted by mini-css-extract-plugin
export default {"preqinReportLogo":"AppLoader_preqinReportLogo__wwYhJ","logo":"AppLoader_logo__laapf","fade-in":"AppLoader_fade-in__VB83v"};